<script setup lang="ts">
const props = defineProps<{
  languages: any[]
}>()
const { availableLocales, locale, t } = useI18n()
const switchLocalePath = useSwitchLocalePath()
</script>


<template>
  <div class="items-center gap-2 inline-flex ">
    <template :key="lang" v-for="(lang, index) in languages">
      <NuxtLink :class="{
        'text-sunglow-500': lang.code === locale,
      }" :to="switchLocalePath(lang.code)" class="link text-sm font-bold uppercase">{{ lang.code }}</NuxtLink>
      <div class="h-1 w-1 rounded-full bg-black" v-if="index < languages.length - 1"></div>
    </template>
  </div>
</template>
